export const categoriesMetaData = {
  'how-we-work': {
    metaTitle: 'Tag: How we work | Yellow',
    metaDescription: 'Read about our most successful projects. The Yellow team reveals its tips and tricks on their blog!',
    pageTitle: 'How we work',
  },
  'software-development': {
    metaTitle: 'Tag: Software Development | Yellow',
    metaDescription: "In this section, we bring you the latest software development news and insights. Don't miss reading!",
    pageTitle: 'Software Development',
  },
  'software-chat': {
    metaTitle: 'Tag: Software Chat | Yellow',
    metaDescription: 'The Yellow team will reveal to you all the secrets of software chat development: detailed case studies, lists, guides.',
    pageTitle: 'Software Chat',
  },
  fintech: {
    metaTitle: 'Tag: Fintech | Yellow',
    metaDescription: `In this section, we will discuss the best practices of fintech development.
    Lending platforms, trading services, e-wallets, budgeting apps, and more.`,
    pageTitle: 'Fintech',
  },
  yellow: {
    metaTitle: 'Tag: Yellow  | Yellow Blog',
    metaDescription: 'The latest news and achievements of the Yellow team. We share information about our company and its processes.',
    pageTitle: 'Yellow',
  },
};
